import { ROUTE_NAMES_LEGACY_CONNECT_GENERAL } from '@atlassian/jira-common-constants/src/spa-routes';

export const legacyConnectGeneralRoute = {
	name: ROUTE_NAMES_LEGACY_CONNECT_GENERAL,
	path: '/plugins/servlet/ac/:addonKey/:moduleKey',
};
